var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49219 12.8594C4.49219 12.7083 4.55208 12.5781 4.67188 12.4688L9.89062 7.24219C9.96354 7.16406 10.0339 7.11198 10.1016 7.08594C10.1693 7.05469 10.2396 7.03906 10.3125 7.03906C10.4583 7.03906 10.5807 7.08854 10.6797 7.1875C10.7786 7.28125 10.8281 7.39844 10.8281 7.53906C10.8281 7.61198 10.8151 7.68229 10.7891 7.75C10.7682 7.8125 10.7344 7.86719 10.6875 7.91406L8.33594 10.2891L5.67188 12.7656L5.54688 12.4453L7.85156 12.3359H18.4844C18.6354 12.3359 18.7578 12.3854 18.8516 12.4844C18.9505 12.5833 19 12.7083 19 12.8594C19 13.0104 18.9505 13.1354 18.8516 13.2344C18.7578 13.3333 18.6354 13.3828 18.4844 13.3828H7.85156L5.54688 13.2734L5.67188 12.9609L8.33594 15.4297L10.6875 17.8047C10.7344 17.8464 10.7682 17.901 10.7891 17.9688C10.8151 18.0365 10.8281 18.1068 10.8281 18.1797C10.8281 18.3203 10.7786 18.4375 10.6797 18.5312C10.5807 18.6302 10.4583 18.6797 10.3125 18.6797C10.1719 18.6797 10.0443 18.625 9.92969 18.5156L4.67188 13.25C4.55208 13.1354 4.49219 13.0052 4.49219 12.8594Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.5ac5e677.svg";
export { ForwardRef as ReactComponent };